import { SelectNightsCount } from 'entities/tour/ui/search-form-tours/components/select-nights-count'

const SelectNightsPage = () => {
  return <SelectNightsCount />
}

export default SelectNightsPage
